import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <>
        <section
          id='home-section'
          className='relative bg-white overflow-hidden'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='bg-tarnsparent'>
            <nav className='flex justify-between p-6 px-4 bg-blue-600'>
              <div className='flex justify-between items-center w-full'>
                <div className='w-1/2 xl:w-1/3'>
                  <a className='block max-w-max' href='#'>
                    <img
                      className='rounded-2xl'
                      src='images/Professory2ndApprovedLogo-png-1697522439479-webp-1697792546278.webp'
                      alt=''
                    />
                  </a>
                </div>
                <div className=' flex justify-between w-1/2 xl:w-1/3'>
                  <ul className=' xl:flex xl:justify-center'>
                    <li className='mr-12'>
                      <a
                        className='hover:text-coolGray-900 font-medium text-white'
                        href='#about-section'
                      >
                        About
                      </a>
                    </li>
                    <li className='mr-12'>
                      <a
                        className='font-medium text-white hover:text-coolGray-900'
                        href='#feature-section'
                      >
                        Features
                      </a>
                    </li>
                    <li>
                      <a
                        className='hover:text-coolGray-900 font-medium text-white'
                        href='#contact-section'
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className='w-1/2 xl:w-1/3'>
                  <div className=' xl:flex items-center justify-end'>
                    <a
                      className='inline-block py-2 px-4 mr-2 leading-5 text-coolGray-500 hover:text-coolGray-900 bg-transparent font-medium rounded-md hidden'
                      href='#'
                    >
                      Log In
                    </a>
                    <a
                      className='inline-block py-2 px-4 text-sm leading-5 text-green-50 hover:bg-green-600 font-medium focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md bg-green-900 hidden'
                      href='#'
                    >
                      Sign Up
                    </a>
                  </div>
                </div>
              </div>
              <button className='font-medium text-white'>
                Change Language
              </button>
            </nav>
            <div className='navbar-menu hidden fixed top-0 left-0 z-50 w-full h-full bg-coolGray-900 bg-opacity-50'>
              <div className='fixed top-0 left-0 bottom-0 w-full w-4/6 max-w-xs bg-red-500'>
                <nav className='relative p-6 h-full overflow-y-auto'>
                  <div className='flex flex-col justify-between h-full'>
                    <a className='inline-block' href='#'>
                      <img
                        className='h-8'
                        src='flex-ui-assets/logos/flex-ui-green-light.svg'
                        alt=''
                      />
                    </a>
                    <ul className='py-6'>
                      <li>
                        <a
                          className='block py-3 px-4 text-coolGray-500 hover:text-coolGray-900 font-medium hover:bg-coolGray-50 rounded-md'
                          href='#'
                        >
                          Product
                        </a>
                      </li>
                      <li>
                        <a
                          className='block py-3 px-4 text-coolGray-500 hover:text-coolGray-900 font-medium hover:bg-coolGray-50 rounded-md'
                          href='#'
                        >
                          Features
                        </a>
                      </li>
                      <li>
                        <a
                          className='block py-3 px-4 text-coolGray-500 hover:text-coolGray-900 font-medium hover:bg-coolGray-50 rounded-md'
                          href='#'
                        >
                          Pricing
                        </a>
                      </li>
                      <li>
                        <a
                          className='block py-3 px-4 text-coolGray-500 hover:text-coolGray-900 font-medium hover:bg-coolGray-50 rounded-md'
                          href='#'
                        >
                          Resources
                        </a>
                      </li>
                    </ul>
                    <div className='flex flex-wrap'>
                      <div className='w-full mb-2'>
                        <a
                          className='inline-block py-2 px-4 w-full text-sm leading-5 text-coolGray-500 hover:text-coolGray-900 bg-transparent font-medium text-center rounded-md'
                          href='#'
                        >
                          Log In
                        </a>
                      </div>
                      <div className='w-full'>
                        <a
                          className='inline-block py-2 px-4 w-full text-sm leading-5 text-white bg-green-500 hover:bg-green-600 font-medium text-center focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md'
                          href='#'
                        >
                          Sign Up
                        </a>
                      </div>
                    </div>
                  </div>
                </nav>
                <a className='navbar-close absolute top-5 p-4 right-3' href='#'>
                  <svg
                    width={12}
                    height={12}
                    viewBox='0 0 12 12'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.94004 6L11.14 1.80667C11.2656 1.68113 11.3361 1.51087 11.3361 1.33333C11.3361 1.1558 11.2656 0.985537 11.14 0.860002C11.0145 0.734466 10.8442 0.66394 10.6667 0.66394C10.4892 0.66394 10.3189 0.734466 10.1934 0.860002L6.00004 5.06L1.80671 0.860002C1.68117 0.734466 1.51091 0.663941 1.33337 0.663941C1.15584 0.663941 0.985576 0.734466 0.860041 0.860002C0.734505 0.985537 0.66398 1.1558 0.66398 1.33333C0.66398 1.51087 0.734505 1.68113 0.860041 1.80667L5.06004 6L0.860041 10.1933C0.797555 10.2553 0.747959 10.329 0.714113 10.4103C0.680267 10.4915 0.662842 10.5787 0.662842 10.6667C0.662842 10.7547 0.680267 10.8418 0.714113 10.9231C0.747959 11.0043 0.797555 11.078 0.860041 11.14C0.922016 11.2025 0.99575 11.2521 1.07699 11.2859C1.15823 11.3198 1.24537 11.3372 1.33337 11.3372C1.42138 11.3372 1.50852 11.3198 1.58976 11.2859C1.671 11.2521 1.74473 11.2025 1.80671 11.14L6.00004 6.94L10.1934 11.14C10.2554 11.2025 10.3291 11.2521 10.4103 11.2859C10.4916 11.3198 10.5787 11.3372 10.6667 11.3372C10.7547 11.3372 10.8419 11.3198 10.9231 11.2859C11.0043 11.2521 11.0781 11.2025 11.14 11.14C11.2025 11.078 11.2521 11.0043 11.286 10.9231C11.3198 10.8418 11.3372 10.7547 11.3372 10.6667C11.3372 10.5787 11.3198 10.4915 11.286 10.4103C11.2521 10.329 11.2025 10.2553 11.14 10.1933L6.94004 6Z'
                      fill='#556987'
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>
        <div className='flex flex-wrap -mx-4 -mb-4 md:mb-0'></div>
        <section
          className='py-24 md:pt-36 bg-white overflow-hidden'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='flex-row justify-between'>
              <div className='flex flex-wrap items-center -mx-4 justify-between bg-white'>
                <div className='w-full md:w-1/2 px-4 mb-16 md:mb-0' style={{}}>
                  <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium rounded-full shadow-sm'>
                    Application
                  </span>
                  <h3 className='mb-4 text-4xl md:text-5xl leading-tight text-coolGray-900 font-bold tracking-tighter'>
                    Get Professory App Now
                  </h3>
                  <p className='mb-6 text-lg md:text-xl text-coolGray-500 font-medium'>
                    With our large library of universities, colleges, majors,
                    subjects, professors, Our App can help you in your college
                    journey. Join us.
                  </p>
                  <div className='flex flex-wrap'>
                    <a
                      className='w-full md:w-auto mb-3 md:mb-0 md:mr-4'
                      href='https://apps.apple.com/kw/app/professory/id1048213048'
                    >
                      <img
                        src='flex-ui-assets/elements/app-store-dark.svg'
                        alt=''
                      />
                    </a>
                    <a
                      className='w-full md:w-auto'
                      href='https://play.google.com/store/apps/details?id=com.barmjni.App.shlondry&pcampaignid=web_share'
                    >
                      <img
                        src='flex-ui-assets/elements/google-play-dark.svg'
                        alt=''
                      />
                    </a>
                  </div>
                </div>
                <div className='w-full lg:w-1/3 px-4 mb-8 lg:mb-0'>
                  <img
                    className='mx-auto'
                    src='images/allLogos2.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          id='feature-section'
          className='py-24 bg-white'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='xl:max-w-4xl mb-12 mx-auto text-center'>
              <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-full shadow-sm'>
                Features
              </span>
              <h1 className='mb-4 text-3xl md:text-4xl leading-tight font-bold tracking-tighter'>
                Get familiar with our features!
              </h1>
              <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                Professory provides the student with a variety of unique
                features, here are some:
              </p>
            </div>
            <div className='flex flex-wrap -mx-4 '>
              <div className='w-full lg:w-1/3 px-4 lg:pt-6 mb-8 lg:mb-0'>
                <div className='p-8 lg:mb-6 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex h-16 w-16 mb-6 mx-auto items-center justify-center text-white rounded-lg bg-blue-500'>
                    <img
                      width={24}
                      height={21}
                      viewbox='0 0 24 21'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/rating-3.png'
                      className='w-12 h-12'
                    />
                  </div>
                  <h3
                    className='mb-4 text-xl md:text-2xl leading-tight font-bold'
                    contentEditable='false'
                  >
                    Professor Rating
                  </h3>
                  <p
                    className='text-coolGray-500 font-medium'
                    contentEditable='false'
                  >
                    Have an idea about your professors through reading fellow
                    students' ratings and experiences with them
                  </p>
                </div>
                <div className='p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex h-16 w-16 mb-6 mx-auto items-center justify-center text-white rounded-lg bg-blue-500'>
                    <img
                      width={24}
                      height={24}
                      viewbox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/books-3.png'
                      className='w-12'
                    />
                  </div>
                  <h3 className='mb-4 text-xl md:text-2xl leading-tight font-bold'>
                    Book Store
                  </h3>
                  <p
                    className='text-coolGray-500 font-medium'
                    contentEditable='false'
                  >
                    Buy and sell used your academic books and contribute to our
                    student community
                  </p>
                </div>
              </div>
              <div className='w-full lg:w-1/3 px-4 mb-8 lg:mb-0 justify-center items-center flex flex-wrap'>
                <div className='p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex h-16 w-16 mb-6 mx-auto items-center justify-center text-white rounded-lg bg-blue-500'>
                    <img
                      width={24}
                      height={24}
                      viewbox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/rating-2-3.png'
                      className='w-12'
                    />
                  </div>
                  <h3 className='mb-4 text-xl md:text-2xl leading-tight font-bold'>
                    Subject Rating
                  </h3>
                  <p
                    className='text-coolGray-500 font-medium'
                    contentEditable='false'
                  >
                    Have an idea about your subjects through reading fellow
                    students' ratings and experiences with them
                  </p>
                </div>
                <div className='p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex h-16 w-16 mb-6 mx-auto items-center justify-center text-white rounded-lg bg-blue-500'>
                    <img
                      width={24}
                      height={24}
                      viewbox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/robot-3.png'
                      className='w-12'
                    />
                  </div>
                  <h3
                    className='mb-4 text-xl md:text-2xl leading-tight font-bold'
                    contentEditable='false'
                  >
                    Ask Me
                  </h3>
                  <p
                    className='text-coolGray-500 font-medium'
                    contentEditable='false'
                  >
                    Ask our AI powered by OpenAI about any subject and obtain
                    precise answers{' '}
                  </p>
                </div>
              </div>
              <div className='w-full lg:w-1/3 lg:pt-6 px-4'>
                <div className='p-8 lg:mb-6 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex h-16 w-16 mb-6 mx-auto items-center justify-center text-white rounded-lg bg-blue-500'>
                    <img
                      width={22}
                      height={12}
                      viewbox='0 0 22 12'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/calculator-3.png'
                      className='w-12 h-12'
                    />
                  </div>
                  <h3 className='mb-4 text-xl md:text-2xl leading-tight font-bold'>
                    GPA Calculator{' '}
                  </h3>
                  <p className='text-coolGray-500 font-medium'>
                    Accurately calculate your overall GPA at any given time
                  </p>
                </div>
                <div className='p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200'>
                  <div className='inline-flex mb-6 mx-auto items-center justify-center text-white   rounded-lg bg-blue-500 w-16 h-16'>
                    <img
                      width={24}
                      height={24}
                      viewbox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      src='images/help-3.png'
                      className='w-12 h-12'
                    />
                  </div>
                  <h3
                    className='mb-4 text-xl md:text-2xl leading-tight font-bold'
                    contentEditable='false'
                  >
                    Help Me
                  </h3>
                  <p
                    className='text-coolGray-500 font-medium'
                    contentEditable='false'
                  >
                    This feature under development. Stay Tuned
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className='py-20 xl:pt-24'
          style={{
            backgroundImage:
              'url("images/pattern-5.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='mb-8 text-center'>
              <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
                Our Clients
              </span>
              <h3 className='mb-4 text-4xl md:text-5xl font-bold tracking-tighter'>
                Trusted by the top universites&nbsp;&nbsp;
              </h3>
              <p className='text-lg md:text-xl font-medium'>
                The app is the number #1 used app by the students. Thank you all
                for trust us.
              </p>
            </div>
            <div className='flex flex-wrap justify-center -mx-4'>
              <div className='w-1/2 md:w-1/3 lg:w-1/5 px-4 mb-8 lg:mb-0'>
                <div className='flex items-center h-32 md:h-36 px-4 md:px-8 rounded-md shadow-md bg-white'>
                  <img
                    className='mx-auto'
                    src='images/aum.jpg'
                    alt=''
                  />
                </div>
              </div>
              <div className='w-1/2 md:w-1/3 lg:w-1/5 px-4 mb-8 lg:mb-0'>
                <div className='flex items-center h-32 md:h-36 px-4 md:px-8 rounded-md shadow-md bg-white'>
                  <img
                    className='mx-auto h-28'
                    src='images/paaet-png-1697525943160.webp'
                    alt=''
                  />
                </div>
              </div>
              <div className='w-1/2 md:w-1/3 lg:w-1/5 px-4 mb-8 lg:mb-0'>
                <div className='flex items-center h-32 md:h-36 px-4 md:px-8 rounded-md shadow-md bg-white'>
                  <img
                    className='mx-auto h-28'
                    src='images/kuniv.png'
                    alt=''
                  />
                </div>
              </div>
              <div className='w-1/2 md:w-1/3 lg:w-1/5 px-4 mb-8 md:mb-0'>
                <div className='flex items-center h-32 md:h-36 px-4 md:px-8 rounded-md shadow-md bg-white'>
                  <img
                    className='mx-auto h-28'
                    src='images/American-University-of-Kuwait2.png'
                    alt=''
                  />
                </div>
              </div>
              <div className='w-1/2 md:w-1/3 lg:w-1/5 px-4'>
                <div className='flex items-center h-32 md:h-36 px-4 md:px-8 rounded-md shadow-md bg-white'>
                  <img
                    className='mx-auto h-28'
                    src='images/guest.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className='py-20 xl:py-24 bg-white'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto bg-white'>
            <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
              Numbers
            </span>
            <h3 className='mb-4 text-4xl md:text-5xl text-coolGray-900 font-bold tracking-tighter'>
              Professory Data
            </h3>
            <p className='mb-16 xl:mb-24 text-lg md:text-xl text-coolGray-500 font-medium max-w-3xl'>
              Since the first luanch of the application back then at 2015,
              Professory has now&nbsp;
            </p>
            <div className='flex flex-wrap items-center -mx-4 text-center'>
              <div className='w-full md:w-1/2 px-4 mb-16 md:mb-0'>
                <div className='flex flex-wrap justify-center -mx-4'>
                  <div className='w-full md:w-1/2 px-4 mb-8'>
                    <h2 className='mb-4 text-4xl lg:text-5xl font-bold tracking-tighter text-blue-500'>
                      11
                    </h2>
                    <h3 className='mb-2 text-lg md:text-xl text-coolGray-800 font-bold'>
                      Countries
                    </h3>
                    <p className='text-coolGray-500 font-medium'>
                      Kuwait, Saudi Arabia, UAE, Bahrain, Qatar, Oman,
                      Jordan, Egypt, Canada, UK, and USA
                    </p>
                  </div>
                  <div className='w-full md:w-1/2 px-4 mb-8'>
                    <h2 className='mb-4 text-4xl lg:text-5xl font-bold tracking-tighter text-blue-500'>
                      +137
                    </h2>
                    <h3 className='mb-2 text-lg md:text-xl text-coolGray-800 font-bold'>
                      Universities
                    </h3>
                    <p className='text-coolGray-500 font-medium'>
                      More universities can be added based on request
                    </p>
                  </div>
                  <div className='w-full md:w-1/2 px-4 mb-8 md:mb-0'>
                    <h2 className='mb-4 text-4xl lg:text-5xl font-bold tracking-tighter text-blue-500'>
                      +82,000
                    </h2>
                    <h3 className='mb-2 text-lg lg:text-xl text-coolGray-800 font-bold'>
                      Professors
                    </h3>
                    <p className='text-coolGray-500 font-medium'>
                      More professors can be added based on request
                    </p>
                  </div>
                  <div className='w-full md:w-1/2 px-4'>
                    <h2 className='mb-4 text-4xl lg:text-5xl font-bold tracking-tighter text-blue-500'>
                      +60,000
                    </h2>
                    <h3 className='mb-2 text-lg md:text-xl text-coolGray-800 font-bold'>
                      Unique Users
                    </h3>
                    <p className='text-coolGray-500 font-medium'>
                      Each use can enjoy our last data set
                    </p>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 px-4'>
                <img
                  className='mx-auto md:mr-0'
                  src='images/Professory2ndApprovedLogo-png-1697522439479.webp'
                  alt=''
                />
              </div>
            </div>
          </div>
        </section>
        <section className='wave-top wave-bottom'>
          <div className='wave wave-top w-full text-coolGray-900'></div>
          <div
            className='md:py-24 bg-blue-500'
            style={{
              backgroundImage:
                'url("images/pattern-4.svg")',
              backgroundPosition: 'center',
            }}
          >
            <div className='container px-4 mx-auto'>
              <div className='relative max-w-5xl sm:px-6 pb-6 mb-10 mx-auto text-center'>
                <img
                  className='absolute top-0 left-0'
                  src='flex-ui-assets/elements/testimonials/quote-top-dark.svg'
                  alt=''
                />
                <img
                  className='absolute bottom-0 right-0'
                  src='flex-ui-assets/elements/testimonials/quote-down-dark.svg'
                  alt=''
                />
                <div className='relative'>
                  <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
                    Quotes
                  </span>
                  <h2 className='text-2xl md:text-5xl font-semibold tracking-tighter'>
                    Professory is the best app for students who seek for a
                    decent academic performance, highly recommended!
                  </h2>
                </div>
              </div>
              <div className='text-center mb-8'>
                <img
                  className='w-24 h-24 mx-auto mb-6 rounded-full'
                  src='flex-ui-assets/images/testimonials/avatar1.png'
                  alt=''
                />
                <h3 className='mb-2 text-xl md:text-2xl font-semibold'>
                  Ahmed Jaber Abdullah
                </h3>
                <span className='text-lg text-coolGray-600 font-medium'>
                  Professor at AUM
                </span>
              </div>
            </div>
          </div>
          <div className='wave wave-bottom w-full text-coolGray-900'></div>
        </section>
        <section
          className='py-24 md:pb-28 bg-white'
          style={{
            backgroundImage:
              'url("images/pattern-2.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='mb-16'>
              <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
                Quotes
              </span>
              <h2 className='mb-4 text-4xl md:text-5xl leading-tight font-semibold tracking-tighter'>
                What people say about us
              </h2>
              <p className='text-xl font-medium text-coolGray-500'>
                We Thrive to provide our user the best experience possible .
              </p>
            </div>
            <div className='flex flex-wrap -mx-4'>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4 mb-8'>
                <div className='flex flex-col h-full p-8 shadow-md rounded-md bg-blue-200'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    The best solution for anyone who wants to work a flexible
                    schedule but still earn a full-time income.
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>
                    Macauley Herring
                  </h4>
                  <p className='text-lg text-coolGray-400'>
                    CEO &amp; Founder at Flex.co
                  </p>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4 mb-8'>
                <div className='flex flex-col h-full p-8 bg-coolGray-50 shadow-md rounded-md'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    I just can't get enough of Flex. I want to get a T-Shirt
                    with Flex on it so I can show it off to everyone. I will
                    recommend you to my colleagues.
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>Ivan Mathews</h4>
                  <p className='text-lg text-coolGray-400'>CTO at Flex.co</p>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4 mb-8'>
                <div className='flex flex-col h-full p-8 bg-coolGray-50 shadow-md rounded-md'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    You won't regret it. We've seen amazing results already.
                    Thanks guys, keep up the good work!
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>Elen Benitez</h4>
                  <p className='text-lg text-coolGray-400'>CPO at Flex.co</p>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4 mb-8 lg:mb-0'>
                <div className='flex flex-col h-full p-8 bg-coolGray-50 shadow-md rounded-md'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    Flex impressed me on multiple levels. I use Flex often. I
                    would be lost without Flex. Flex is the real deal!
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>Kacy Wade</h4>
                  <p className='text-lg text-coolGray-400'>
                    Customer Success at Flex.co
                  </p>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4 mb-8 md:mb-0'>
                <div className='flex flex-col h-full p-8 bg-coolGray-50 shadow-md rounded-md'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    Flex was worth a fortune to my company. I couldn't have
                    asked for more than this.
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>Alya Levine</h4>
                  <p className='text-lg text-coolGray-400'>
                    Backend Developer at Flex.co
                  </p>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 px-4'>
                <div className='flex flex-col h-full p-8 bg-coolGray-50 shadow-md rounded-md'>
                  <h3 className='pb-14 mb-auto text-xl md:text-2xl font-medium'>
                    Thanks for the great service. Flex did exactly what you said
                    it does. Just what I was looking for.
                  </h3>
                  <h4 className='mb-1 text-lg font-semibold'>
                    Rosemary Hernandez
                  </h4>
                  <p className='text-lg text-coolGray-400'>
                    Product Designer at Flex.co
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          id='contact-section'
          className='py-20 bg-white'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='flex flex-wrap mb-24 lg:mb-18 justify-between items-center'>
              <div className='w-full lg:w-1/2 mb-10 lg:mb-0'>
                <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
                  Contact
                </span>
                <h3
                  className='mb-4 text-4xl md:text-5xl text-darkCoolGray-900 font-bold tracking-tighter leading-tight'
                  contentEditable='false'
                >
                  Let’s stay connected
                </h3>
                <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                  It's never been easier to get in touch with Professory . Call
                  us, use our live chat widget or email and we'll get back to
                  you as soon as possible!
                </p>
              </div>
              <div className='w-full lg:w-auto'>
                <div className='flex flex-wrap justify-center items-center md:justify-start -mb-2'></div>
              </div>
            </div>
            <div className='flex flex-wrap -mx-4'>
              <div className='w-full lg:w-1/2 px-4 mb-14 lg:mb-0'>
                <div className='flex flex-wrap -mx-4'>
                  <div className='w-full md:w-1/2 px-4 mb-10'>
                    <div className='max-w-xs mx-auto'>
                      <div className='inline-flex mb-6 items-center justify-center w-12 h-12 rounded-full bg-blue-500'>
                        <svg
                          className='h-6 text-white'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M20.21 8.82L14 2.78C13.474 2.27986 12.7759 2.00095 12.05 2.00095C11.3241 2.00095 10.626 2.27986 10.1 2.78L3.89 8.78C3.61408 9.02087 3.39216 9.31731 3.23879 9.64991C3.08541 9.98251 3.00404 10.3438 3 10.71V19.29C3.01054 20.0176 3.30904 20.7114 3.83012 21.2193C4.35119 21.7273 5.05235 22.008 5.78 22H18.22C18.9476 22.008 19.6488 21.7273 20.1699 21.2193C20.691 20.7114 20.9895 20.0176 21 19.29V10.71C20.9992 10.3585 20.929 10.0106 20.7935 9.68623C20.6579 9.36189 20.4596 9.06752 20.21 8.82V8.82ZM11.44 4.22C11.593 4.08016 11.7927 4.00262 12 4.00262C12.2073 4.00262 12.407 4.08016 12.56 4.22L18 9.5L12.53 14.78C12.377 14.9198 12.1773 14.9974 11.97 14.9974C11.7627 14.9974 11.563 14.9198 11.41 14.78L6 9.5L11.44 4.22ZM19 19.29C18.9871 19.4863 18.8987 19.6699 18.7532 19.8023C18.6078 19.9347 18.4166 20.0056 18.22 20H5.78C5.58338 20.0056 5.39225 19.9347 5.24678 19.8023C5.10132 19.6699 5.01286 19.4863 5 19.29V11.35L9.05 15.25L7.39 16.85C7.20375 17.0374 7.09921 17.2908 7.09921 17.555C7.09921 17.8192 7.20375 18.0726 7.39 18.26C7.48295 18.3575 7.59463 18.4352 7.71836 18.4885C7.84208 18.5418 7.97529 18.5695 8.11 18.57C8.36747 18.569 8.61462 18.4687 8.8 18.29L10.57 16.59C11.0096 16.8586 11.5148 17.0008 12.03 17.0008C12.5452 17.0008 13.0504 16.8586 13.49 16.59L15.26 18.29C15.4454 18.4687 15.6925 18.569 15.95 18.57C16.0847 18.5695 16.2179 18.5418 16.3416 18.4885C16.4654 18.4352 16.5771 18.3575 16.67 18.26C16.8563 18.0726 16.9608 17.8192 16.9608 17.555C16.9608 17.2908 16.8563 17.0374 16.67 16.85L15 15.25L19 11.35V19.29Z'
                            fill='currentColor'
                          />
                        </svg>
                      </div>
                      <h3 className='mb-4 text-2xl md:text-3xl font-bold leading-9 text-coolGray-900'>
                        Email
                      </h3>
                      <a
                        className='text-lg md:text-xl text-coolGray-500 hover:text-coolGray-600 font-medium'
                        href='mailto:#'
                      >
                        professoryapp@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className='w-full md:w-1/2 px-4 mb-10'>
                    <div className='max-w-xs mx-auto'>
                      <div className='inline-flex mb-6 items-center justify-center w-12 h-12 rounded-full bg-blue-500'>
                        <svg
                          className='h-6 text-white'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M19.41 13C19.1901 13 18.96 12.93 18.74 12.88C18.2949 12.7805 17.8572 12.6501 17.43 12.49C16.9661 12.3212 16.4562 12.33 15.9984 12.5146C15.5405 12.6992 15.1671 13.0466 14.95 13.49L14.73 13.95C13.7589 13.3992 12.8617 12.7271 12.0601 11.95C11.2829 11.1484 10.6108 10.2512 10.0601 9.28L10.5201 9.07C10.9634 8.85292 11.3108 8.47953 11.4954 8.02169C11.6801 7.56385 11.6888 7.05391 11.5201 6.59C11.3612 6.15903 11.231 5.71808 11.13 5.27C11.08 5.05 11.04 4.82 11.01 4.6C10.8886 3.89562 10.5197 3.25774 9.96967 2.80124C9.41967 2.34474 8.72475 2.09961 8.01005 2.11H5.00005C4.5773 2.10945 4.1592 2.19825 3.77317 2.37058C3.38714 2.54292 3.04189 2.7949 2.76005 3.11C2.47237 3.43365 2.25817 3.81575 2.13215 4.23004C2.00614 4.64432 1.97131 5.08098 2.03005 5.51C2.57364 9.67214 4.47526 13.5387 7.44005 16.51C10.4114 19.4748 14.2779 21.3764 18.4401 21.92C18.5699 21.9299 18.7002 21.9299 18.83 21.92C19.5675 21.9211 20.2794 21.6505 20.83 21.16C21.1452 20.8782 21.3971 20.5329 21.5695 20.1469C21.7418 19.7609 21.8306 19.3428 21.83 18.92V15.92C21.8247 15.229 21.5809 14.5611 21.14 14.0291C20.6991 13.4971 20.088 13.1336 19.41 13ZM19.9 19C19.8997 19.1395 19.8702 19.2775 19.8134 19.4049C19.7565 19.5324 19.6736 19.6465 19.57 19.74C19.4604 19.8399 19.33 19.9141 19.1882 19.9573C19.0464 20.0006 18.8967 20.0117 18.75 19.99C15.0183 19.5026 11.5503 17.802 8.88005 15.15C6.20752 12.4775 4.49208 8.99737 4.00005 5.25C3.97833 5.10333 3.98949 4.95367 4.03272 4.81185C4.07596 4.67003 4.1502 4.5396 4.25005 4.43C4.34467 4.32515 4.46043 4.24154 4.5897 4.18466C4.71897 4.12778 4.85882 4.09892 5.00005 4.1H8.00005C8.23121 4.09435 8.45719 4.16898 8.63951 4.3112C8.82184 4.45341 8.94925 4.65442 9.00005 4.88C9.00005 5.15 9.09005 5.43 9.15005 5.7C9.26563 6.22386 9.41937 6.73857 9.61005 7.24L8.21005 7.9C7.96941 8.01046 7.78241 8.21185 7.69005 8.46C7.59003 8.70346 7.59003 8.97654 7.69005 9.22C9.12925 12.3028 11.6073 14.7808 14.69 16.22C14.9335 16.32 15.2066 16.32 15.45 16.22C15.6982 16.1276 15.8996 15.9406 16.01 15.7L16.64 14.3C17.156 14.4881 17.6838 14.6418 18.22 14.76C18.48 14.82 18.76 14.87 19.0301 14.91C19.2556 14.9608 19.4566 15.0882 19.5989 15.2705C19.7411 15.4529 19.8157 15.6788 19.81 15.91L19.9 19ZM14 2C13.7701 2 13.53 2 13.3 2C13.0348 2.02254 12.7894 2.14952 12.6178 2.353C12.4462 2.55647 12.3625 2.81978 12.385 3.085C12.4076 3.35022 12.5346 3.59562 12.738 3.76721C12.9415 3.93881 13.2048 4.02254 13.47 4H14C15.5913 4 17.1175 4.63214 18.2427 5.75736C19.3679 6.88258 20 8.4087 20 10C20 10.18 20 10.35 20 10.53C19.9779 10.7938 20.0612 11.0556 20.2318 11.2581C20.4024 11.4606 20.6463 11.5871 20.91 11.61H20.99C21.2404 11.611 21.482 11.5181 21.6671 11.3496C21.8523 11.1811 21.9675 10.9493 21.99 10.7C21.99 10.47 21.99 10.23 21.99 10C21.9901 7.88 21.1486 5.84668 19.6504 4.34668C18.1523 2.84667 16.12 2.00265 14 2ZM16 10C16 10.2652 16.1054 10.5196 16.2929 10.7071C16.4805 10.8946 16.7348 11 17 11C17.2653 11 17.5196 10.8946 17.7072 10.7071C17.8947 10.5196 18 10.2652 18 10C18 8.93913 17.5786 7.92172 16.8285 7.17157C16.0783 6.42143 15.0609 6 14 6C13.7348 6 13.4805 6.10536 13.2929 6.29289C13.1054 6.48043 13 6.73478 13 7C13 7.26522 13.1054 7.51957 13.2929 7.70711C13.4805 7.89464 13.7348 8 14 8C14.5305 8 15.0392 8.21071 15.4143 8.58579C15.7893 8.96086 16 9.46957 16 10Z'
                            fill='currentColor'
                          />
                        </svg>
                      </div>
                      <h3 className='mb-4 text-2xl md:text-3xl font-bold leading-9 text-coolGray-900'>
                        Phone
                      </h3>
                      <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                        +965 xxx xx xx
                      </p>
                    </div>
                  </div>
                  <div className='w-full md:w-1/2 px-4 mb-10 md:mb-0'>
                    <div className='max-w-xs mx-auto'>
                      <div className='inline-flex mb-6 items-center justify-center w-12 h-12 bg-green-500 rounded-full bg-blue-500'>
                        <svg
                          className='h-6 text-white'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M18.0001 4.48C16.4088 2.8887 14.2505 1.99472 12.0001 1.99472C9.74961 1.99472 7.59135 2.8887 6.00005 4.48C4.40875 6.0713 3.51477 8.22957 3.51477 10.48C3.51477 12.7304 4.40875 14.8887 6.00005 16.48L11.2701 21.76C11.363 21.8537 11.4736 21.9281 11.5955 21.9789C11.7173 22.0297 11.848 22.0558 11.9801 22.0558C12.1121 22.0558 12.2428 22.0297 12.3646 21.9789C12.4865 21.9281 12.5971 21.8537 12.6901 21.76L18.0001 16.43C19.5847 14.8453 20.4749 12.6961 20.4749 10.455C20.4749 8.21395 19.5847 6.06468 18.0001 4.48ZM16.5701 15L12.0001 19.59L7.43005 15C6.5272 14.0963 5.91253 12.9452 5.66375 11.6923C5.41497 10.4393 5.54324 9.14075 6.03236 7.96068C6.52147 6.78062 7.34947 5.77205 8.41168 5.06248C9.4739 4.35291 10.7226 3.97418 12.0001 3.97418C13.2775 3.97418 14.5262 4.35291 15.5884 5.06248C16.6506 5.77205 17.4786 6.78062 17.9677 7.96068C18.4569 9.14075 18.5851 10.4393 18.3364 11.6923C18.0876 12.9452 17.4729 14.0963 16.5701 15ZM9.00005 7.41C8.19277 8.21977 7.73945 9.31657 7.73945 10.46C7.73945 11.6034 8.19277 12.7002 9.00005 13.51C9.59981 14.1108 10.3636 14.5211 11.1957 14.6894C12.0278 14.8577 12.891 14.7766 13.6771 14.4562C14.4632 14.1357 15.1372 13.5903 15.6145 12.8883C16.0918 12.1862 16.3512 11.3589 16.3601 10.51C16.3646 9.94321 16.2554 9.38126 16.039 8.85739C15.8225 8.33352 15.5033 7.85836 15.1001 7.46C14.7037 7.05458 14.2311 6.73154 13.7095 6.50947C13.1878 6.2874 12.6274 6.17068 12.0605 6.16603C11.4935 6.16138 10.9313 6.2689 10.406 6.48239C9.8808 6.69588 9.40297 7.01113 9.00005 7.41ZM13.6901 12.09C13.3111 12.4747 12.8103 12.7159 12.2732 12.7723C11.7361 12.8286 11.1961 12.6966 10.7456 12.3989C10.295 12.1012 9.96185 11.6562 9.80306 11.1401C9.64427 10.6239 9.6697 10.0686 9.87501 9.56916C10.0803 9.06967 10.4528 8.65702 10.9286 8.40174C11.4045 8.14646 11.9543 8.06441 12.484 8.16962C13.0137 8.27483 13.4904 8.56076 13.8326 8.97853C14.1748 9.39631 14.3612 9.91997 14.3601 10.46C14.3455 11.0773 14.0865 11.6635 13.6401 12.09H13.6901Z'
                            fill='currentColor'
                          />
                        </svg>
                      </div>
                      <h3 className='mb-4 text-2xl md:text-3xl font-bold leading-9 text-coolGray-900'>
                        Office
                      </h3>
                      <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                        Sanabel Tower
                      </p>
                      <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                        Jaber Al Mubarak St, Kuwait City
                      </p>
                    </div>
                  </div>
                  <div className='w-full md:w-1/2 px-4'>
                    <div className='max-w-xs mx-auto flex-col items-center justify-center'>
                      <div className='inline-flex mb-6 items-center justify-center w-12 h-12 rounded-full bg-blue-500'>
                        <svg
                          className='h-6 text-white'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2V2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z'
                            fill='currentColor'
                          />
                        </svg>
                      </div>
                      <h3 className='mb-9 text-2xl md:text-3xl font-bold leading-9 text-coolGray-900'>
                        Socials
                      </h3>
                      <a
                        className='inline-block mr-8 text-green-500 hover:text-green-600'
                        href='#'
                      ></a>
                      <a
                        className='inline-block mr-8 hover:text-green-600 text-blue-500'
                        href='https://x.com/ProfessoryApp?s=20'
                      >
                        <svg
                          width={19}
                          height={16}
                          viewBox='0 0 19 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M18.8181 2.14598C18.1356 2.44844 17.4032 2.65356 16.6336 2.74513C17.4194 2.27462 18.0208 1.52831 18.3059 0.641769C17.5689 1.0775 16.7553 1.39389 15.8885 1.56541C15.1943 0.82489 14.2069 0.363647 13.1118 0.363647C11.0108 0.363647 9.30722 2.06719 9.30722 4.16707C9.30722 4.46489 9.34083 4.75577 9.40574 5.03392C6.24434 4.87513 3.44104 3.3605 1.56483 1.05895C1.23686 1.61986 1.05028 2.27344 1.05028 2.9711C1.05028 4.29107 1.72243 5.45574 2.74225 6.13713C2.11877 6.11628 1.53237 5.94477 1.01901 5.65968V5.70719C1.01901 7.5498 2.33086 9.08762 4.07031 9.43762C3.75161 9.52337 3.41555 9.57089 3.06789 9.57089C2.82222 9.57089 2.58464 9.54656 2.35171 9.50019C2.8361 11.0125 4.24068 12.1123 5.90483 12.1424C4.6034 13.1623 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4279 6.10416 15.4279C13.1026 15.4279 16.928 9.63116 16.928 4.60398L16.9153 4.11147C17.6627 3.57834 18.3094 2.90853 18.8181 2.14598Z'
                            fill='currentColor'
                          />
                        </svg>
                      </a>
                      <a
                        className='inline-block mr-8 hover:text-green-600 text-blue-500'
                        href='#https://instagram.com/professoryapp?igshid=MWZjMTM2ODFkZg=='
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox='0 0 24 22'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M7.60057 2.18182H16.3991C19.3872 2.18182 21.8182 4.61282 21.8181 7.60075V16.3993C21.8181 19.3872 19.3872 21.8182 16.3991 21.8182H7.60057C4.61264 21.8182 2.18176 19.3873 2.18176 16.3993V7.60075C2.18176 4.61282 4.61264 2.18182 7.60057 2.18182ZM16.3992 20.076C18.4266 20.076 20.076 18.4266 20.076 16.3993H20.0759V7.60075C20.0759 5.57349 18.4265 3.92406 16.3991 3.92406H7.60057C5.57331 3.92406 3.924 5.57349 3.924 7.60075V16.3993C3.924 18.4266 5.57331 20.0761 7.60057 20.076H16.3992ZM6.85709 12.0001C6.85709 9.16424 9.16413 6.85715 11.9999 6.85715C14.8358 6.85715 17.1428 9.16424 17.1428 12.0001C17.1428 14.8359 14.8358 17.1429 11.9999 17.1429C9.16413 17.1429 6.85709 14.8359 6.85709 12.0001ZM8.62792 12C8.62792 13.8593 10.1407 15.3719 11.9999 15.3719C13.8592 15.3719 15.372 13.8593 15.372 12C15.372 10.1406 13.8593 8.62791 11.9999 8.62791C10.1406 8.62791 8.62792 10.1406 8.62792 12Z'
                            fill='currentColor'
                          />
                          <mask
                            id='mask0_382_5883'
                            style={{ maskType: 'alpha' }}
                            maskUnits='userSpaceOnUse'
                            x={2}
                            y={2}
                            width={20}
                            height={20}
                          >
                            <path
                              fillRule='evenodd'
                              clipRule='evenodd'
                              d='M7.60057 2.18182H16.3991C19.3872 2.18182 21.8182 4.61282 21.8181 7.60075V16.3993C21.8181 19.3872 19.3872 21.8182 16.3991 21.8182H7.60057C4.61264 21.8182 2.18176 19.3873 2.18176 16.3993V7.60075C2.18176 4.61282 4.61264 2.18182 7.60057 2.18182ZM16.3992 20.076C18.4266 20.076 20.076 18.4266 20.076 16.3993H20.0759V7.60075C20.0759 5.57349 18.4265 3.92406 16.3991 3.92406H7.60057C5.57331 3.92406 3.924 5.57349 3.924 7.60075V16.3993C3.924 18.4266 5.57331 20.0761 7.60057 20.076H16.3992ZM6.85709 12.0001C6.85709 9.16424 9.16413 6.85715 11.9999 6.85715C14.8358 6.85715 17.1428 9.16424 17.1428 12.0001C17.1428 14.8359 14.8358 17.1429 11.9999 17.1429C9.16413 17.1429 6.85709 14.8359 6.85709 12.0001ZM8.62792 12C8.62792 13.8593 10.1407 15.3719 11.9999 15.3719C13.8592 15.3719 15.372 13.8593 15.372 12C15.372 10.1406 13.8593 8.62791 11.9999 8.62791C10.1406 8.62791 8.62792 10.1406 8.62792 12Z'
                              fill='white'
                            />
                          </mask>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full lg:w-1/2 px-4'>
                <div className='px-4 py-8 md:p-10 bg-coolGray-50 rounded-md'>
                  <form>
                    <div className='mb-6'>
                      <label
                        className='block mb-2 text-coolGray-800 font-medium leading-6'
                        htmlFor=''
                      >
                        Email
                      </label>
                      <input
                        className='block w-full py-2 px-3 appearance-none border border-coolGray-200 rounded-lg shadow-md text-coolGray-500 leading-6 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50'
                        type='email'
                        placeholder='Ex: myEmail@gmail.com'
                      />
                    </div>
                    <div className='mb-6'>
                      <label
                        className='block mb-2 text-coolGray-800 font-medium leading-6'
                        htmlFor=''
                      >
                        Message
                      </label>
                      <textarea
                        className='block h-32 md:h-52 w-full py-2 px-3 appearance-none border border-coolGray-200 rounded-lg shadow-md text-coolGray-500 leading-6 focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 placeholder-coolGray-200 resize-none'
                        type='text'
                        placeholder='Your message...'
                        defaultValue={''}
                      />
                    </div>
                    <button className='block w-full py-4 px-6 text-lg leading-6 text-coolGray-50 font-medium text-center hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm bg-blue-500'>
                      Send
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          id='about-section'
          className='relative py-24 bg-white'
          style={{
            backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='relative container px-4 mx-auto'>
            <div className='mb-16 text-center'>
              <span className='inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl'>
                Team
              </span>
              <h3 className='mb-4 text-3xl md:text-5xl leading-tight text-coolGray-900 font-bold tracking-tighter'>
                Professory App team Who made it possiable
              </h3>
              <p className='text-lg md:text-xl text-coolGray-500 font-medium'>
                We Are committed to provide our users the best experience
                possible
              </p>
            </div>
            <div className='flex flex-wrap -mx-4'>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar7.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg font-semibold text-coolGray-800 font-semibold'>
                    Abdulaziz Alshamma
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium  text-green-500'
                    contentEditable='false'
                  >
                    Founder &amp; App Development
                  </span>
                  <div className='flex items-center justify-center'>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={10}
                        height={18}
                        viewBox='0 0 10 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M6.63494 17.7273V9.76602H9.3583L9.76688 6.66246H6.63494V4.68128C6.63494 3.78301 6.88821 3.17085 8.20297 3.17085L9.87712 3.17017V0.394238C9.5876 0.357335 8.59378 0.272728 7.43708 0.272728C5.0217 0.272728 3.3681 1.71881 3.3681 4.37391V6.66246H0.636475V9.76602H3.3681V17.7273H6.63494Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={19}
                        height={16}
                        viewBox='0 0 19 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M18.8181 2.14597C18.1356 2.44842 17.4032 2.65355 16.6336 2.74512C17.4194 2.27461 18.0208 1.5283 18.3059 0.641757C17.5689 1.07748 16.7553 1.39388 15.8885 1.56539C15.1943 0.824879 14.2069 0.363636 13.1118 0.363636C11.0108 0.363636 9.30722 2.06718 9.30722 4.16706C9.30722 4.46488 9.34083 4.75576 9.40574 5.03391C6.24434 4.87512 3.44104 3.36048 1.56483 1.05894C1.23686 1.61985 1.05028 2.27342 1.05028 2.97109C1.05028 4.29106 1.72243 5.45573 2.74225 6.13712C2.11877 6.11627 1.53237 5.94476 1.01901 5.65967V5.70718C1.01901 7.54979 2.33086 9.08761 4.07031 9.43761C3.75161 9.52336 3.41555 9.57088 3.06789 9.57088C2.82222 9.57088 2.58464 9.54655 2.35171 9.50018C2.8361 11.0125 4.24067 12.1123 5.90483 12.1424C4.6034 13.1622 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4278 6.10416 15.4278C13.1026 15.4278 16.928 9.63115 16.928 4.60397L16.9153 4.11145C17.6627 3.57833 18.3094 2.90851 18.8181 2.14597Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block text-coolGray-300 hover:text-coolGray-400'
                      href=''
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M5.6007 0.181818H14.3992C17.3874 0.181818 19.8184 2.61281 19.8182 5.60074V14.3993C19.8182 17.3872 17.3874 19.8182 14.3992 19.8182H5.6007C2.61276 19.8182 0.181885 17.3873 0.181885 14.3993V5.60074C0.181885 2.61281 2.61276 0.181818 5.6007 0.181818ZM14.3993 18.0759C16.4267 18.0759 18.0761 16.4266 18.0761 14.3993H18.076V5.60074C18.076 3.57348 16.4266 1.92405 14.3992 1.92405H5.6007C3.57343 1.92405 1.92412 3.57348 1.92412 5.60074V14.3993C1.92412 16.4266 3.57343 18.0761 5.6007 18.0759H14.3993ZM4.85721 10.0001C4.85721 7.16424 7.16425 4.85714 10.0001 4.85714C12.8359 4.85714 15.1429 7.16424 15.1429 10.0001C15.1429 12.8359 12.8359 15.1429 10.0001 15.1429C7.16425 15.1429 4.85721 12.8359 4.85721 10.0001ZM6.62805 10C6.62805 11.8593 8.14081 13.3719 10.0001 13.3719C11.8593 13.3719 13.3721 11.8593 13.3721 10C13.3721 8.14058 11.8594 6.6279 10.0001 6.6279C8.14069 6.6279 6.62805 8.14058 6.62805 10Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar2.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg text-coolGray-800 font-semibold'>
                    Ali Abbas
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium text-green-500'
                    contentEditable='false'
                  >
                    Strategic&nbsp;Manager
                  </span>
                  <div className='flex items-center justify-center'>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={10}
                        height={18}
                        viewBox='0 0 10 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M6.63494 17.7273V9.76602H9.3583L9.76688 6.66246H6.63494V4.68128C6.63494 3.78301 6.88821 3.17085 8.20297 3.17085L9.87712 3.17017V0.394238C9.5876 0.357335 8.59378 0.272728 7.43708 0.272728C5.0217 0.272728 3.3681 1.71881 3.3681 4.37391V6.66246H0.636475V9.76602H3.3681V17.7273H6.63494Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={19}
                        height={16}
                        viewBox='0 0 19 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M18.8181 2.14597C18.1356 2.44842 17.4032 2.65355 16.6336 2.74512C17.4194 2.27461 18.0208 1.5283 18.3059 0.641757C17.5689 1.07748 16.7553 1.39388 15.8885 1.56539C15.1943 0.824879 14.2069 0.363636 13.1118 0.363636C11.0108 0.363636 9.30722 2.06718 9.30722 4.16706C9.30722 4.46488 9.34083 4.75576 9.40574 5.03391C6.24434 4.87512 3.44104 3.36048 1.56483 1.05894C1.23686 1.61985 1.05028 2.27342 1.05028 2.97109C1.05028 4.29106 1.72243 5.45573 2.74225 6.13712C2.11877 6.11627 1.53237 5.94476 1.01901 5.65967V5.70718C1.01901 7.54979 2.33086 9.08761 4.07031 9.43761C3.75161 9.52336 3.41555 9.57088 3.06789 9.57088C2.82222 9.57088 2.58464 9.54655 2.35171 9.50018C2.8361 11.0125 4.24067 12.1123 5.90483 12.1424C4.6034 13.1622 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4278 6.10416 15.4278C13.1026 15.4278 16.928 9.63115 16.928 4.60397L16.9153 4.11145C17.6627 3.57833 18.3094 2.90851 18.8181 2.14597Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M5.6007 0.181818H14.3992C17.3874 0.181818 19.8184 2.61281 19.8182 5.60074V14.3993C19.8182 17.3872 17.3874 19.8182 14.3992 19.8182H5.6007C2.61276 19.8182 0.181885 17.3873 0.181885 14.3993V5.60074C0.181885 2.61281 2.61276 0.181818 5.6007 0.181818ZM14.3993 18.0759C16.4267 18.0759 18.0761 16.4266 18.0761 14.3993H18.076V5.60074C18.076 3.57348 16.4266 1.92405 14.3992 1.92405H5.6007C3.57343 1.92405 1.92412 3.57348 1.92412 5.60074V14.3993C1.92412 16.4266 3.57343 18.0761 5.6007 18.0759H14.3993ZM4.85721 10.0001C4.85721 7.16424 7.16425 4.85714 10.0001 4.85714C12.8359 4.85714 15.1429 7.16424 15.1429 10.0001C15.1429 12.8359 12.8359 15.1429 10.0001 15.1429C7.16425 15.1429 4.85721 12.8359 4.85721 10.0001ZM6.62805 10C6.62805 11.8593 8.14081 13.3719 10.0001 13.3719C11.8593 13.3719 13.3721 11.8593 13.3721 10C13.3721 8.14058 11.8594 6.6279 10.0001 6.6279C8.14069 6.6279 6.62805 8.14058 6.62805 10Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar3.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg text-coolGray-800 font-semibold'>
                    Mahdi Al-Koot
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium text-green-500'
                    contentEditable='false'
                  >
                    Logistics Manger
                  </span>
                  <div className='flex items-center justify-center'>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={10}
                        height={18}
                        viewBox='0 0 10 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M6.63494 17.7273V9.76602H9.3583L9.76688 6.66246H6.63494V4.68128C6.63494 3.78301 6.88821 3.17085 8.20297 3.17085L9.87712 3.17017V0.394238C9.5876 0.357335 8.59378 0.272728 7.43708 0.272728C5.0217 0.272728 3.3681 1.71881 3.3681 4.37391V6.66246H0.636475V9.76602H3.3681V17.7273H6.63494Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={19}
                        height={16}
                        viewBox='0 0 19 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M18.8181 2.14597C18.1356 2.44842 17.4032 2.65355 16.6336 2.74512C17.4194 2.27461 18.0208 1.5283 18.3059 0.641757C17.5689 1.07748 16.7553 1.39388 15.8885 1.56539C15.1943 0.824879 14.2069 0.363636 13.1118 0.363636C11.0108 0.363636 9.30722 2.06718 9.30722 4.16706C9.30722 4.46488 9.34083 4.75576 9.40574 5.03391C6.24434 4.87512 3.44104 3.36048 1.56483 1.05894C1.23686 1.61985 1.05028 2.27342 1.05028 2.97109C1.05028 4.29106 1.72243 5.45573 2.74225 6.13712C2.11877 6.11627 1.53237 5.94476 1.01901 5.65967V5.70718C1.01901 7.54979 2.33086 9.08761 4.07031 9.43761C3.75161 9.52336 3.41555 9.57088 3.06789 9.57088C2.82222 9.57088 2.58464 9.54655 2.35171 9.50018C2.8361 11.0125 4.24067 12.1123 5.90483 12.1424C4.6034 13.1622 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4278 6.10416 15.4278C13.1026 15.4278 16.928 9.63115 16.928 4.60397L16.9153 4.11145C17.6627 3.57833 18.3094 2.90851 18.8181 2.14597Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M5.6007 0.181818H14.3992C17.3874 0.181818 19.8184 2.61281 19.8182 5.60074V14.3993C19.8182 17.3872 17.3874 19.8182 14.3992 19.8182H5.6007C2.61276 19.8182 0.181885 17.3873 0.181885 14.3993V5.60074C0.181885 2.61281 2.61276 0.181818 5.6007 0.181818ZM14.3993 18.0759C16.4267 18.0759 18.0761 16.4266 18.0761 14.3993H18.076V5.60074C18.076 3.57348 16.4266 1.92405 14.3992 1.92405H5.6007C3.57343 1.92405 1.92412 3.57348 1.92412 5.60074V14.3993C1.92412 16.4266 3.57343 18.0761 5.6007 18.0759H14.3993ZM4.85721 10.0001C4.85721 7.16424 7.16425 4.85714 10.0001 4.85714C12.8359 4.85714 15.1429 7.16424 15.1429 10.0001C15.1429 12.8359 12.8359 15.1429 10.0001 15.1429C7.16425 15.1429 4.85721 12.8359 4.85721 10.0001ZM6.62805 10C6.62805 11.8593 8.14081 13.3719 10.0001 13.3719C11.8593 13.3719 13.3721 11.8593 13.3721 10C13.3721 8.14058 11.8594 6.6279 10.0001 6.6279C8.14069 6.6279 6.62805 8.14058 6.62805 10Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar4.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg text-coolGray-800 font-semibold'>
                    Hussain Alshamma
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium text-green-500'
                    contentEditable='false'
                  >
                    App Operations Manger
                  </span>
                  <div className='flex items-center justify-center'>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={10}
                        height={18}
                        viewBox='0 0 10 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M6.63494 17.7273V9.76602H9.3583L9.76688 6.66246H6.63494V4.68128C6.63494 3.78301 6.88821 3.17085 8.20297 3.17085L9.87712 3.17017V0.394238C9.5876 0.357335 8.59378 0.272728 7.43708 0.272728C5.0217 0.272728 3.3681 1.71881 3.3681 4.37391V6.66246H0.636475V9.76602H3.3681V17.7273H6.63494Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block mr-5 text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={19}
                        height={16}
                        viewBox='0 0 19 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M18.8181 2.14597C18.1356 2.44842 17.4032 2.65355 16.6336 2.74512C17.4194 2.27461 18.0208 1.5283 18.3059 0.641757C17.5689 1.07748 16.7553 1.39388 15.8885 1.56539C15.1943 0.824879 14.2069 0.363636 13.1118 0.363636C11.0108 0.363636 9.30722 2.06718 9.30722 4.16706C9.30722 4.46488 9.34083 4.75576 9.40574 5.03391C6.24434 4.87512 3.44104 3.36048 1.56483 1.05894C1.23686 1.61985 1.05028 2.27342 1.05028 2.97109C1.05028 4.29106 1.72243 5.45573 2.74225 6.13712C2.11877 6.11627 1.53237 5.94476 1.01901 5.65967V5.70718C1.01901 7.54979 2.33086 9.08761 4.07031 9.43761C3.75161 9.52336 3.41555 9.57088 3.06789 9.57088C2.82222 9.57088 2.58464 9.54655 2.35171 9.50018C2.8361 11.0125 4.24067 12.1123 5.90483 12.1424C4.6034 13.1622 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4278 6.10416 15.4278C13.1026 15.4278 16.928 9.63115 16.928 4.60397L16.9153 4.11145C17.6627 3.57833 18.3094 2.90851 18.8181 2.14597Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                    <a
                      className='inline-block text-coolGray-300 hover:text-coolGray-400'
                      href='#'
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M5.6007 0.181818H14.3992C17.3874 0.181818 19.8184 2.61281 19.8182 5.60074V14.3993C19.8182 17.3872 17.3874 19.8182 14.3992 19.8182H5.6007C2.61276 19.8182 0.181885 17.3873 0.181885 14.3993V5.60074C0.181885 2.61281 2.61276 0.181818 5.6007 0.181818ZM14.3993 18.0759C16.4267 18.0759 18.0761 16.4266 18.0761 14.3993H18.076V5.60074C18.076 3.57348 16.4266 1.92405 14.3992 1.92405H5.6007C3.57343 1.92405 1.92412 3.57348 1.92412 5.60074V14.3993C1.92412 16.4266 3.57343 18.0761 5.6007 18.0759H14.3993ZM4.85721 10.0001C4.85721 7.16424 7.16425 4.85714 10.0001 4.85714C12.8359 4.85714 15.1429 7.16424 15.1429 10.0001C15.1429 12.8359 12.8359 15.1429 10.0001 15.1429C7.16425 15.1429 4.85721 12.8359 4.85721 10.0001ZM6.62805 10C6.62805 11.8593 8.14081 13.3719 10.0001 13.3719C11.8593 13.3719 13.3721 11.8593 13.3721 10C13.3721 8.14058 11.8594 6.6279 10.0001 6.6279C8.14069 6.6279 6.62805 8.14058 6.62805 10Z'
                          fill='currentColor'
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10 xl:mb-0'></div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-10 md:mb-0'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar1.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg text-coolGray-800 font-semibold'>
                    Mahdi Al-Mosawi
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium text-green-500'
                    contentEditable='false'
                  >
                    Marketing Manger
                  </span>
                  <div className='flex items-center justify-center'>
                    <a className='inline-block mr-4 hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/facebook.svg' alt='' />
                    </a>
                    <a className='inline-block mr-4 hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/twitter.svg' alt='' />
                    </a>
                    <a className='inline-block hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/instagram.svg' alt='' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4'>
                <div className='text-center max-w-xs mx-auto'>
                  <img
                    className='w-24 h-24 mx-auto mb-6 rounded-full'
                    src='flex-ui-assets/images/teams/avatar8.png'
                    alt=''
                  />
                  <h3 className='mb-1 text-lg text-coolGray-800 font-semibold'>
                    Khalel
                  </h3>
                  <span
                    className='inline-block mb-6 text-lg font-medium text-green-500'
                    contentEditable='false'
                  >
                    UI/UX Designer
                  </span>
                  <div className='flex items-center justify-center'>
                    <a className='inline-block mr-4 hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/facebook.svg' alt='' />
                    </a>
                    <a className='inline-block mr-4 hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/twitter.svg' alt='' />
                    </a>
                    <a className='inline-block hover:opacity-80' href='#'>
                      <img src='flex-ui-assets/brands/instagram.svg' alt='' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className='py-24 bg-white overflow-hidden'
          style={{
            backgroundImage:
              'url("images/pattern-2.svg")',
            backgroundPosition: 'center',
          }}
        >
          <div className='container px-4 mx-auto'>
            <div className='flex flex-wrap -mx-4'>
              <div className='w-full md:w-1/2 px-4 mb-20 lg:mb-0'>
                <div className='max-w-md mx-auto'>
                  <h2 className='mb-8 text-4xl md:text-5xl font-heading font-bold text-coolGray-900 md:leading-15'>
                    Join +60,000 students who are already on Professory!
                  </h2>
                  <ul className='mb-8'>
                    <li className='flex items-center mb-4'>
                      <img
                        className='mr-3'
                        src='flex-ui-assets/elements/cta/checkbox-green.svg'
                        alt=''
                      />
                      <span className='text-lg md:text-xl font-heading text-coolGray-500'>
                        More than 35,000 student comments
                      </span>
                    </li>
                    <li className='flex items-center mb-4'>
                      <img
                        className='mr-3'
                        src='flex-ui-assets/elements/cta/checkbox-green.svg'
                        alt=''
                      />
                      <span className='text-lg md:text-xl font-heading text-coolGray-500'>
                        More than 200 listed books
                      </span>
                    </li>
                    <li className='flex items-center'>
                      <img
                        className='mr-3'
                        src='flex-ui-assets/elements/cta/checkbox-green.svg'
                        alt=''
                      />
                      <span className='text-lg md:text-xl font-heading text-coolGray-500'>
                        More than 21.1 Million user interactions
                      </span>
                    </li>
                  </ul>
                  <div className='flex flex-wrap items-center'></div>
                </div>
              </div>
              <div className='w-full md:w-1/2 px-4'>
                <div className='relative max-w-max mx-auto'>
                  <img
                    className='absolute top-0 right-0 -mt-6 lg:-mt-12 -mr-6 lg:-mr-12 w-20 lg:w-auto z-10'
                    src='flex-ui-assets/elements/circle3-yellow.svg'
                    alt=''
                  />
                  <img
                    className='absolute bottom-0 left-0 -mb-6 lg:-mb-10-ml-6 lg:-ml-12 w-20 lg:w-auto'
                    src='flex-ui-assets/elements/dots3-blue.svg'
                    alt=''
                  />
                  <img
                    className='relative'
                    src='flex-ui-assets/elements/cta/photo-laptop-ph.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className='flex flex-wrap'>
              <a
                className='w-full md:w-auto mb-3 md:mb-0 md:mr-4'
                href='https://apps.apple.com/kw/app/professory/id1048213048'
              >
                <img src='flex-ui-assets/elements/app-store-dark.svg' alt='' />
              </a>
              <a
                className='w-full md:w-auto'
                href='https://play.google.com/store/apps/details?id=com.barmjni.App.shlondry&pcampaignid=web_share'
              >
                <img
                  src='flex-ui-assets/elements/google-play-dark.svg'
                  alt=''
                />
              </a>
            </div>
            <div className='w-full md:w-1/2 mb-6 md:mb-0'></div>
          </div>
        </section>
        <section className='bg-white'>
          <div className='wave-top w-full text-coolGray-900'></div>
          <div
            className='overflow-hidden bg-green-500\'
            style={{
              backgroundImage:
                'url("images/pattern-3.svg")',
              backgroundPosition: 'center',
            }}
          >
            <div className='container px-4 mx-auto'></div>
            <div className='border-b border-coolGray-800' />
            <div className='container px-4 mx-auto'>
              <div className='flex items-center'>
                <div className='w-full md:w-1/2 mb-6 md:mb-0'>
                  <p className='font-medium'>
                    © 2015 Barmjni Solutions. All rights reserved.
                  </p>
                </div>
                <div className='w-full md:w-1/2'>
                  <div className='flex flex-wrap md:justify-end -mx-5'>
                    <div className='px-5'>
                      <a
                        className='inline-block text-coolGray-400 hover:text-coolGray-500'
                        href='#'
                      >
                        <svg
                          width={10}
                          height={18}
                          viewBox='0 0 10 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        ></svg>
                      </a>
                    </div>
                    <div className='px-5'>
                      <a
                        className='inline-block hover:text-coolGray-500 text-blue-500'
                        href='https://x.com/ProfessoryApp?s=20'
                      >
                        <svg
                          width={19}
                          height={16}
                          viewBox='0 0 19 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M18.8181 2.14597C18.1356 2.44842 17.4032 2.65355 16.6336 2.74512C17.4194 2.27461 18.0208 1.5283 18.3059 0.641757C17.5689 1.07748 16.7553 1.39388 15.8885 1.56539C15.1943 0.824879 14.2069 0.363636 13.1118 0.363636C11.0108 0.363636 9.30722 2.06718 9.30722 4.16706C9.30722 4.46488 9.34083 4.75576 9.40574 5.03391C6.24434 4.87512 3.44104 3.36048 1.56483 1.05894C1.23686 1.61985 1.05028 2.27342 1.05028 2.97109C1.05028 4.29106 1.72243 5.45573 2.74225 6.13712C2.11877 6.11627 1.53237 5.94476 1.01901 5.65967V5.70718C1.01901 7.54979 2.33086 9.08761 4.07031 9.43761C3.75161 9.52336 3.41555 9.57088 3.06789 9.57088C2.82222 9.57088 2.58464 9.54655 2.35171 9.50018C2.8361 11.0125 4.24067 12.1123 5.90483 12.1424C4.6034 13.1622 2.96243 13.7683 1.1801 13.7683C0.873008 13.7683 0.570523 13.7498 0.272705 13.7162C1.95655 14.7974 3.95561 15.4278 6.10416 15.4278C13.1026 15.4278 16.928 9.63115 16.928 4.60397L16.9153 4.11145C17.6627 3.57833 18.3094 2.90851 18.8181 2.14597Z'
                            fill='currentColor'
                          />
                        </svg>
                      </a>
                    </div>
                    <div className='px-5'>
                      <a
                        className='inline-block hover:text-coolGray-500 text-blue-500'
                        href='https://instagram.com/professoryapp?igshid=MWZjMTM2ODFkZg=='
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M5.6007 0.181818H14.3992C17.3874 0.181818 19.8184 2.61281 19.8182 5.60074V14.3993C19.8182 17.3872 17.3874 19.8182 14.3992 19.8182H5.6007C2.61276 19.8182 0.181885 17.3873 0.181885 14.3993V5.60074C0.181885 2.61281 2.61276 0.181818 5.6007 0.181818ZM14.3993 18.0759C16.4267 18.0759 18.0761 16.4266 18.0761 14.3993H18.076V5.60074C18.076 3.57348 16.4266 1.92405 14.3992 1.92405H5.6007C3.57343 1.92405 1.92412 3.57348 1.92412 5.60074V14.3993C1.92412 16.4266 3.57343 18.0761 5.6007 18.0759H14.3993ZM4.85721 10.0001C4.85721 7.16424 7.16425 4.85714 10.0001 4.85714C12.8359 4.85714 15.1429 7.16424 15.1429 10.0001C15.1429 12.8359 12.8359 15.1429 10.0001 15.1429C7.16425 15.1429 4.85721 12.8359 4.85721 10.0001ZM6.62805 10C6.62805 11.8593 8.14081 13.3719 10.0001 13.3719C11.8593 13.3719 13.3721 11.8593 13.3721 10C13.3721 8.14058 11.8594 6.6279 10.0001 6.6279C8.14069 6.6279 6.62805 8.14058 6.62805 10Z'
                            fill='currentColor'
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}

